import React, { useState, useEffect } from 'react';
import { Booking } from '../../../models/booking';
import { CalendarToday, DirectionsCar, Person, LocationOn, InfoOutlined, ElectricCar, ChevronRight, People, Luggage, ArrowForward, ExpandMore } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { getCar } from '../../../services/carsService';
import { getDriver } from '../../../services/driverService';
import { dateFormat } from '../common/dateUtils';
import { carColor, paymentStatusColor, statusColor } from '../common/bookingUtils';
import { AppContext } from '../../../services/AppContext';
import "../../../../styles/commonStyle.css"
import { useMediaQuery, useTheme } from '@mui/material';

interface BookingItemProps {
  bookings: Booking[];
}

const BookingItemNext: React.FC<BookingItemProps> = ({ bookings }) => {
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handlePress = (booking: Booking) => {
    AppContext.setBooking(booking);
    navigate('/userBookingDetailsPage', { state: { booking } });
  };


  if (bookings.length === 0) {
    return (
      <div className="cardNoRides">
        <div className="noRidesIcon">
          <InfoOutlined fontSize='large' style={{ color: '#6c757d' }} />
        </div>
        <h5 className="fw-bold text-dark mb-1">No UpComing Rides</h5>
        <p className="text-muted mb-0 customText">
          Looks like you haven’t booked a ride yet.
      </p>
      </div>

    );
  }

  return (
    <>
      <div className="container my-4">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-9 px-0">
            {bookings.map((booking) => (
              <React.Fragment key={booking.bookingId}>
                {isMobile ? (
                  <div
                    className="shadow-sm mb-2 bg-white d-flex align-items-center px-3 py-2  border-top border-bottom rounded-0"
                    style={{
                      width: '100vw',
                      marginLeft: '-12px',
                      marginRight: '-12px',
                      cursor: 'pointer'
                    }}
                    onClick={() => handlePress(booking)}
                  >

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <ElectricCar className="me-2" fontSize="small" style={{ color: carColor(booking) }} />
                      <div className="text-start">
                        <div className="fw-bold">
                          {booking.fromCity} → {booking.toCity}
                        </div>
                        <div className="customTextXs" style={{ color: '#666' }}>
                          {booking.returnRide ? 'Return' : 'OneWay'} – {booking.selectedCarModel}
                        </div>

                        <div className="customTextXs" style={{ color: carColor(booking), }}>
                          On {dateFormat(booking.bookingDate)}
                        </div>
                      </div>
                    </div>

                    <ChevronRight className="ms-auto" style={{ color: '#888', }} />
                  </div>


                ) : (

                    <div className="card border shadow-sm mb-4"
                      style={{ cursor: 'pointer' }}
                      onClick={() => handlePress(booking)}
                    >
                      {/* header */}
                      <div className="position-relative p-4 border-bottom"
                        style={{
                          boxShadow: '0 4px 8px rgba(0,0,0,0.06)',
                          zIndex: 1,
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h6 className="mb-1 ms-2 d-flex align-items-center gap-2">
                              <ElectricCar fontSize="small" style={{ color: carColor(booking) }} />
                              <strong style={{ color: carColor(booking) }}>
                                {booking.fromCity} → {booking.toCity}
                              </strong>
                              <span className="badge fw-semibold px-2 py-1 customTextXs"
                                style={{ backgroundColor: '#e3f2fd', color: '#0d47a1' }}>
                                {dateFormat(booking.bookingDate)}
                              </span>
                            </h6>
                            <div className="text-muted small ms-2">
                              <small className="d-flex flex-wrap align-items-center gap-2">
                                <span className="badge border fw-semibold px-2 py-1 customTextXs"
                                  style={{ color: '#455a64' }}>
                                  {booking.returnRide ? 'Return' : 'OneWay'}
                                </span>
                                <span>&bull;</span>
                                <strong style={{ color: statusColor(booking) }}>
                                  {booking.status === 'NEW' ? 'CONFIRMING' : booking.status}
                                </strong>
                                <span>&bull;</span>
                                <strong >
                                  Booking ID - {booking.bookingId}
                                </strong>
                              </small>
                            </div>
                          </div>
                          <button className="btn btn-primary btn-sm" onClick={() => handlePress(booking)}>
                            View Details
                      </button>
                        </div>
                      </div>

                      <div className="p-4">
                        <div className="row g-4">
                          <div className="col-md-4 text-start">
                            <div className="text-uppercase text-muted small mb-1">Pickup</div>
                            <div className="small text-muted fw-semibold">{booking.fromAddress}</div>
                          </div>
                          <div className="col-md-4 text-start">
                            <div className="text-uppercase text-muted small mb-1">Drop</div>
                            <div className="small text-muted fw-semibold">{booking.toAddress}</div>
                          </div>
                          <div className="col-md-4 text-start">
                            <div className="text-uppercase text-muted small mb-1">Cab Info</div>
                            <div className="small text-muted fw-semibold">{booking.selectedCarModel}</div>
                          </div>
                        </div>

                        <div className="mt-4 d-flex">
                          <div className="alert alert-warning d-flex align-items-center p-2 customTextSm"
                            style={{ width: '80%' }}>
                            <InfoOutlined fontSize="small" className="me-2" />
                        Driver & Cab details will be sent 24 hrs prior to departure
                      </div>
                        </div>
                      </div>
                    </div>
                  )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

    </>
  );
};

export default BookingItemNext;











// <div className="container px-0">
// {bookings.map((booking, index) => (
//   <div
//     key={index}
//     onClick={() => handlePress(booking)}
//     className="card mb-3 shadow-sm"
//     style={{
//       borderRadius: '1rem',
//       border: '1px solid #eee',
//       boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
//       cursor: 'pointer',
//       transition: 'box-shadow 0.2s',
//       background: '#fff',
//       overflow: 'hidden',
//       minWidth: 0,
//     }}
//   >
//     <div
//       className="card-header py-2 px-3"
//       style={{
//         borderBottom: '1px solid #f2f2f2',
//         background: 'linear-gradient(90deg, #f8fafc 60%, #f2f6fa 100%)',
//       }}
//     >
//       <div className="d-flex justify-content-between align-items-center">
//       <div className="text-start">
//           <div style={{ fontWeight: 700, fontSize: 16, color: '#222' }}>
//             {booking.fromCity} <span style={{ color: '#aaa' }}>→</span> {booking.toCity}
//           </div>
//           <div className="d-flex align-items-center gap-1 mt-1">
//             <CalendarToday style={{ fontSize: 16, color: carColor(booking) }} />
//             <span style={{ fontSize: 13, color: '#555' }}>{dateFormat(booking.bookingDate)}</span>
//           </div>
//         </div>
//         <div>
//           <StatusChip booking={booking} />
//         </div>
//       </div>
//     </div>

//     <div className="card-body p-3">
//       {/* Pickup & Dropoff */}
//       <div className="row gx-2 mb-2">
//         <div className="col-6">
//           <div style={{ fontSize: 13, color: '#666' }} className="d-flex align-items-center gap-1">
//             <LocationOn style={{ fontSize: 16, color: 'green' }} />
//             <span>Pickup</span>
//           </div>
//           <div style={{ fontSize: 13, color: '#222', textAlign: 'left', wordBreak: 'break-word' }}>
//             {booking.fromAddress}
//           </div>
//         </div>
//         <div className="col-6">
//           <div style={{ fontSize: 13, color: '#666' }} className="d-flex align-items-center gap-1">
//             <LocationOn style={{ fontSize: 16, color: 'red' }} />
//             <span>Dropoff</span>
//           </div>
//           <div style={{ fontSize: 13, color: '#222', textAlign: 'left', wordBreak: 'break-word' }}>
//             {booking.toAddress}
//           </div>
//         </div>
//       </div>

//       {/* Divider */}
//       <div className="my-2" style={{ borderTop: '1px solid #f0f0f0' }}></div>

//       {/* Vehicle, Driver, Passengers */}
//       <div className="row gx-2">
//         <div className="col-6 mb-2">
//           <div className="d-flex align-items-center gap-1 mb-1" style={{ fontSize: 13, fontWeight: 600 }}>
//             <DirectionsCar style={{ fontSize: 16, color: carColor(booking) }} />
//             <span>Vehicle</span>
//           </div>
//           <div className="bg-light rounded px-2 py-1" style={{ fontSize: 12 }}>
//             <div className="text-start">
//               <span style={{ color: '#888' }}>Model: </span>
//               <span>{booking.selectedCarModel}</span>
//             </div>
//             <div className="text-start">
//               <span style={{ color: '#888' }}>Car: </span>
//               <span>{getCar(booking.carId).carNumber}</span>
//             </div>
//           </div>
//         </div>
//         <div className="col-6 mb-2">
//           <div className="d-flex align-items-center gap-1 mb-1" style={{ fontSize: 13, fontWeight: 600 }}>
//             <Person style={{ fontSize: 16, color: carColor(booking) }} />
//             <span>Driver</span>
//           </div>
//           <div className="bg-light rounded px-2 py-1" style={{ fontSize: 12 }}>
//             <div className="text-start">
//               <span style={{ color: '#888' }}>Name: </span>
//               <span>{getDriver(booking.driverId).name}</span>
//             </div>
//           </div>
//         </div>
//         {/* <div className="col-4 mb-2">
//           <div className="d-flex align-items-center gap-1 mb-1" style={{ fontSize: 13, fontWeight: 600 }}>
//             <Person style={{ fontSize: 16, color: carColor(booking) }} />
//             <span>Pax/Luggage</span>
//           </div>
//           <div className="bg-light rounded px-2 py-1" style={{ fontSize: 12 }}>
//             <div className="text-start">
//               <span style={{ color: '#888' }}>Passengers: </span>
//               <span>{booking.numberOfPassengers}</span>
//             </div>
//             <div className="text-start">
//               <span style={{ color: '#888' }}>Luggage: </span>
//               <span>{booking.numberOfBigBags}</span>
//             </div>
//           </div>
//         </div> */}
//       </div>
//     </div>
//   </div>
// ))}
// </div>